import { API } from '@utils/axios'

export async function fetchMarks (params: any) {
  const response = await API.get('/MarkManagement/List', { params })
  return response.data
}

export async function updateMark (data: any) {
  const response = await API.post('/MarkManagement/Update', data)
  return response.data
}

export async function createMark (data: any) {
  const response = await API.post('/MarkManagement/Create', data)
  return response.data
}

export async function deleteMark (id: string) {
  const response = await API.delete(`/MarkManagement/${id}`)
  return response.data
}

export async function fetchAllMarks () {
  const response = await API.get('/MarkManagement/All')
  return response.data
}
